// store/actions/reportStoreFunctions.js

// Actions
export const setReportLoading = (loading) => ({
  type: "REPORTS_SET_LOADING",
  payload: loading
});
export const replaceAllTemplates = (templates) => ({
  type: "REPORTS_REPLACE_ALL_TEMPLATES",
  payload: templates
});
export const addReportTemplate = (tpl) => ({
  type: "REPORTS_ADD_TEMPLATE",
  payload: tpl
});
export const updateReportTemplate = (tpl) => ({
  type: "REPORTS_UPDATE_TEMPLATE",
  payload: tpl
});
export const deleteReportTemplate = (id) => ({
  type: "REPORTS_DELETE_TEMPLATE",
  payload: id
});

// State
const initialState = {
  loading: false,
  templates: []
};

// Reducer
export const reportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "REPORTS_SET_LOADING":
      return { ...state, loading: action.payload };
    case "REPORTS_REPLACE_ALL_TEMPLATES":
      return {
        ...state,
        templates: Array.isArray(action.payload) ? action.payload : []
      };
    case "REPORTS_ADD_TEMPLATE":
      return { ...state, templates: [...state.templates, action.payload] };
    case "REPORTS_UPDATE_TEMPLATE":
      return {
        ...state,
        templates: state.templates.map((t) =>
          String(t.id) === String(action.payload.id) ? action.payload : t
        )
      };
    case "REPORTS_DELETE_TEMPLATE":
      return {
        ...state,
        templates: state.templates.filter(
          (t) => String(t.id) !== String(action.payload)
        )
      };
    default:
      return state;
  }
};
